import { useState, useEffect } from 'react'
import { useNavigate, useSearchParams, Link } from 'react-router-dom'
import axios from 'axios'
import AuthShell from '../../components/common/AuthShell'

export default function VerifyEmail() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [token, setToken] = useState('')
  const [loading, setLoading] = useState(true)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState('')
  const [email, setEmail] = useState('')

  useEffect(() => {
    const tokenParam = searchParams.get('token')
    if (!tokenParam) {
      setError('Kein gültiger Verifizierungs-Token gefunden')
      setLoading(false)
    } else {
      setToken(tokenParam)
      verifyEmail(tokenParam)
    }
  }, [searchParams])

  const verifyEmail = async (tokenValue) => {
    try {
      const response = await axios.post('http://localhost:8000/api/v1/auth/verify-email',
        { token: tokenValue },
        {
          headers: {
            'Content-Type': 'application/json'
          },
          params: { token: tokenValue }
        }
      )
      setSuccess(true)
      setEmail(response.data.email)

      // Nach 5 Sekunden zum Login weiterleiten
      setTimeout(() => {
        navigate('/login')
      }, 5000)
    } catch (err) {
      if (err.response?.status === 400) {
        setError('Ungültiger oder abgelaufener Verifizierungs-Token')
      } else if (err.response?.data?.detail) {
        setError(err.response.data.detail)
      } else {
        setError('Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.')
      }
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <AuthShell title="E-Mail wird verifiziert…" subtitle="Bitte warten Sie einen Moment.">
        <div style={{ display: 'flex', justifyContent: 'center', padding: '12px 0' }}>
          <span className="wc-spinner" role="status" aria-label="E-Mail wird verifiziert" />
        </div>
      </AuthShell>
    )
  }

  if (success) {
    return (
      <AuthShell title="E-Mail erfolgreich bestätigt!">
        <p style={{ fontSize: 14, margin: 0, opacity: 0.85 }}>
          Ihre E-Mail-Adresse <strong>{email}</strong> wurde erfolgreich verifiziert.
          Sie können sich jetzt anmelden und Ihre Apps nutzen.
        </p>
        <p className="wc-muted" style={{ fontSize: 13, margin: 0 }}>
          Sie werden automatisch zum Login weitergeleitet…
        </p>
        <Link to="/login" className="wc-btn wc-btn-primary wc-btn-block">
          Jetzt anmelden
        </Link>
      </AuthShell>
    )
  }

  return (
    <AuthShell title="Verifizierung fehlgeschlagen">
      <div className="wc-alert wc-alert-error" role="alert">
        {error}
      </div>
      <p className="wc-muted" style={{ fontSize: 14, margin: 0 }}>
        Der Verifizierungs-Link ist möglicherweise abgelaufen oder wurde bereits
        verwendet.
      </p>
      <Link to="/login" className="wc-btn wc-btn-secondary wc-btn-block">
        Zum Login
      </Link>
      <p className="wc-muted" style={{ fontSize: 13, margin: 0, textAlign: 'center' }}>
        Benötigen Sie einen neuen Verifizierungs-Link?{' '}
        <Link to="/resend-verification">Link erneut senden</Link>
      </p>
    </AuthShell>
  )
}
